module.exports = __webpack_public_path__ + "static/img/banner_01.5f2d9ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_01.png
// module id = xuzc
// module chunks = 1